<template>
  <MobilePromoCard
    v-if="visible"
    icon="bell"
    :title="$t('mobile.pushBannerTitle')"
    :subtitle="hint || $t('mobile.pushBannerSubtitle')"
    :cta-label="$t('mobile.pushBannerButton')"
    :busy="busy"
    @cta="enable"
  />
</template>

<script>
import {
  getPushState,
  enablePush,
  isInstalledApp,
  PUSH_STATE_EVENT,
} from "@/utils/pushNotifications";
import MobilePromoCard from "./MobilePromoCard.vue";

/**
 * App instalada sin notificaciones activadas: tarjeta fija (sin ✕) para activarlas. Se va
 * sola cuando se activan, desde acá, el menú del usuario o el chat.
 */
export default {
  name: "MobilePushBanner",
  components: { MobilePromoCard },
  data() {
    return { state: "", busy: false, hint: "" };
  },
  computed: {
    visible() {
      return this.state === "off";
    },
  },
  async mounted() {
    window.addEventListener(PUSH_STATE_EVENT, this.onStateChanged);
    if (!isInstalledApp()) return;
    this.state = await getPushState();
  },
  beforeDestroy() {
    window.removeEventListener(PUSH_STATE_EVENT, this.onStateChanged);
  },
  methods: {
    onStateChanged(e) {
      if (isInstalledApp() && e.detail) this.state = e.detail.state;
    },
    async enable() {
      this.busy = true;
      this.hint = "";
      try {
        const result = await enablePush();
        if (result === "denied") this.hint = this.$t("mobile.pushDenied");
        else if (result === "unavailable") this.hint = this.$t("ai.agentChatNotifyUnavailable");
      } catch (e) {
        this.hint = (e.response && e.response.data && e.response.data.error) || e.message;
      } finally {
        this.busy = false;
      }
    },
  },
};
</script>
